import React, { Component } from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import Layout from './containers/Layout/Layout';
import Patients from './containers/Patients/Patients';
import Auth from './containers/Auth/Auth';
import PatientsCreator from './containers/PatientsCreator/PatientsCreator';
import PatientsStatistic from './containers/PatientsStatistic/PatientsStatistic';
import classes from './App.module.css';
import { connect } from 'react-redux';
import Logout from './components/Logout/Logout';
import { autoLogin } from './store/actions/auth.js';
import Zan from './containers/Auth/Zan';

class App extends Component {
  componentDidMount() {
    this.props.autoLogin();
  }

  render() {
    // если пользователь не авторизован скрываем меню и делаем недоступными ссылки
    let routes = (
      <Switch>
        <Route path="/zan" component={Zan} />
        <Route path="/Auth" component={Auth} />

        <Redirect to="/Auth" component={Auth} />
      </Switch>
    );
    // если пользователь авторизован показываем меню и ссылки
    if (this.props.isAuthenticated) {
      routes = (
        <Switch>
          <Layout>
            <Route path="/patients" render={() => <Patients />} />
            <Route
              path="/patients-creator"
              render={() => <PatientsCreator />}
            />
            <Route path="/patients-statistic" component={PatientsStatistic} />
            <Route path="/logout" component={Logout} />
            <Route exact path="/" render={() => <Patients />} />
            <Redirect to="/" />
          </Layout>
        </Switch>
      );
    }

    // Выводим контент страницы
    return <div className={classes.content}>{routes}</div>;
  }
}

function mapStateToProps(state) {
  return {
    isAuthenticated: !!state.auth.token,
  };
}

function mapDispathToProps(dispatch) {
  return {
    autoLogin: () => dispatch(autoLogin()),
  };
}

export default withRouter(connect(mapStateToProps, mapDispathToProps)(App));
